"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class REMCalculator {
    static pxToRem(px) {
        return px / REMCalculator.getCurrentRemToPXRatio();
    }
    static remToPx(rem) {
        return rem * REMCalculator.getCurrentRemToPXRatio();
    }
    static pxStringToRemString(pxString) {
        const match = pxString.match(REMCalculator.PX_REGEX);
        if (match?.length !== 3) {
            throw new Error("Not a px string");
        }
        const px = match[1];
        return `${+px / REMCalculator.getCurrentRemToPXRatio()}rem`;
    }
    static remStringToPxString(remString) {
        const match = remString.match(REMCalculator.REM_REGEX);
        if (match?.length !== 3) {
            throw new Error("Not a rem string");
        }
        const rem = match[1];
        return `${+rem * REMCalculator.getCurrentRemToPXRatio()}px`;
    }
    static getCurrentRemToPXRatio() {
        const root = document.querySelector(":root");
        if (root) {
            const fontSize = window.getComputedStyle(root).fontSize;
            const match = fontSize.match(REMCalculator.PX_REGEX);
            const px = match?.[1];
            if (px) {
                return +px;
            }
        }
        return 16;
    }
}
REMCalculator.PX_REGEX = /^(\d*\.?\d)+(px)$/;
REMCalculator.REM_REGEX = /^(\d*\.?\d)+(rem)$/;
exports.default = REMCalculator;
//# sourceMappingURL=REMCalculator.js.map